import * as API from "@/services/API";

export default {
  getField() {
    return new Promise((resolve, reject) => {
      API.apiClient
        .get(`/contact-us-fields`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  formData(payload) {
    return new Promise((resolve, reject) => {
      API.apiClient
        .post("/contact-us-send-form", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
